
import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { NgForm, FormGroupDirective, FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import { TrackService } from 'src/app/services/track.service';
import { Track } from 'src/app/entities/track';

@Component({
  selector: 'app-add-track',
  templateUrl: './add-track.component.html',
  styleUrls: ['./add-track.component.css']
})
export class AddTrackComponent implements OnInit {

  constructor(private trackService: TrackService,
              private  dialogRef: MatDialogRef<AddTrackComponent>,
              @Inject(MAT_DIALOG_DATA) public data: AddTrackComponent) { }

  track: Track = this.data.track;
  sessionId: number = this.data.sessionId;
  matcher = new MyErrorStateMatcher();
  channel = new FormControl('', [Validators.required, ]);
  sessions = new FormControl('');
  editMode: boolean = this.data.editMode;
  formGroup = new FormGroup({ channel: this.channel, sessions: this.sessions});

  ngOnInit(){
    if (this.track)
    {
      this.channel.setValue(this.track.channel);
    }
  }

  onSubmit(){
    this.matcher.submited = true;
    if (this.formGroup.invalid) {
      return;
    }
    if (this.track){
      this.transformToTrack();
      this.updateTrack();
    }
    else{
      this.track = new Track();
      this.transformToTrack();
      this.AddTrack();
    }
  }

  AddTrack() {
    this.trackService.addTrack(this.track)
      .subscribe(
        (dataSaved) => {
          this.track = dataSaved;
          this.onClose();
        },
        (error) => {
          console.error(error);
        }
      );
  }

  updateTrack(){
    this.trackService.updateTrack(this.track.id, this.track)
    .subscribe(
      (_) => {
        this.onClose();
      },
      error => {
        console.error(error);
      }
    );
  }

  onClose() {
    this.dialogRef.close(this.track);
  }

  transformToTrack(){
    this.track.channel = this.formGroup.get('channel').value;
    this.track.sessionId = this.sessionId;
  }
}
export class MyErrorStateMatcher implements ErrorStateMatcher {
    submited = false;
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      const isSubmitted = this.submited;
      return !!(control && control.invalid && (isSubmitted));
    }
}


